import { render, staticRenderFns } from "./OrganizationUserInvitations.vue?vue&type=template&id=aadc5da0&"
import script from "./OrganizationUserInvitations.vue?vue&type=script&lang=js&"
export * from "./OrganizationUserInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports